import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-inactivity-timeout',
    templateUrl: './inactivity-timeout.component.html'
})
export class InactivityTimeoutComponent implements OnDestroy {

    inactiveTime: number;
    logoutStartTime: Date;
    subscriptions: Subscription[] = [];

    public get secondCount(): number {
        const current = new Date();
        return 60 - Math.round((current.getTime() - this.logoutStartTime.getTime()) / 1000);
    }

    constructor(
        private dialog: MatDialogRef<InactivityTimeoutComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data) {
            this.inactiveTime = data.inactiveTime;
            this.logoutStartTime = data.logoutStartTime;
        }

        ['click', 'touchstart', 'mousemove', 'keydown'].forEach(evt =>
            document.addEventListener(evt, this.closeDialog.bind(this), false)
        );
    }

    ngOnDestroy() {
    }

    closeDialog() {
        this.dialog.close();
    }
}